/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './reminders.reducer';

export const RemindersDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const remindersEntity = useAppSelector(state => state.reminders.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="remindersDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.reminders.detail.title">Reminders</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.reminders.id">Id</Translate>
            </span>
          </dt>
          <dd>{remindersEntity.id}</dd>
          <dt>
            <span id="reminderFor">
              <Translate contentKey="tinyMedicRestApp.reminders.reminderFor">Reminder For</Translate>
            </span>
          </dt>
          <dd>{remindersEntity.reminderFor}</dd>
          <dt>
            <span id="reminderNo">
              <Translate contentKey="tinyMedicRestApp.reminders.reminderNo">Reminder No</Translate>
            </span>
          </dt>
          <dd>{remindersEntity.reminderNo}</dd>
          <dt>
            <span id="reminderTime">
              <Translate contentKey="tinyMedicRestApp.reminders.reminderTime">Reminder Time</Translate>
            </span>
          </dt>
          <dd>{remindersEntity.reminderTime}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.reminders.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{remindersEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.reminders.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{remindersEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.reminders.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{remindersEntity.lastupdated}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.reminders.active">Active</Translate>
            </span>
          </dt>
          <dd>{remindersEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.reminders.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{remindersEntity.cursor}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.reminders.appointment">Appointment</Translate>
          </dt>
          <dd>{remindersEntity.appointment ? remindersEntity.appointment.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.reminders.reminderOptionCode">Reminder Option Code</Translate>
          </dt>
          <dd>{remindersEntity.reminderOptionCode ? remindersEntity.reminderOptionCode.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.reminders.durationCode">Duration Code</Translate>
          </dt>
          <dd>{remindersEntity.durationCode ? remindersEntity.durationCode.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/reminders" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/reminders/${remindersEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default RemindersDetail;
